if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('.cart__form');
			
			if ( document.getElementById('AjaxCartSubtotal').querySelector('#CheckOut')) {
				this.form.addEventListener('submit', event => {	
					const button = document.getElementById('AjaxCartSubtotal').querySelector('#CheckOut');
					button.classList.add('working');
				});
			}

			this.querySelectorAll('[data-js-cart-item]').forEach((item,index)=>{
        index = index;
				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');

          // regenerate cart recommendations if the removed item is the first item in the cart


					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0,index);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})
		}

		updateCartQty(item, newQty, index){

			document.querySelector('cart-recommendations').classList.add('loading');

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

            // const body = JSON.stringify({
			// 	line: parseInt(item.dataset.line),
			// 	quantity: newQty
			// });
          

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

							
					const event = new Event('cart-updated');
					document.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
					document.querySelector('cart-recommendations').generateRecommendations();
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = (generateRecommendations = true, openSidebar = true) => {

		const form = document.querySelector('cart-form').form;
		const actions = form.querySelector('.cart-item__actions')

		if (actions) {
			actions.classList.add('processing');
		}

		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});

			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') && openSidebar ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			document.querySelector('cart-recommendations').classList.remove('loading');

		})
		.finally(() => {
			if (actions) {
				actions.classList.remove('processing');
			}
			if ( document.querySelector('cart-recommendations') && generateRecommendations ) {
				document.querySelector('cart-recommendations').generateRecommendations();
			}
		});

	}

}


(function() {
	const originalFetch = window.fetch; // Store the original fetch function
	const event = new Event('cart-updated');
  
	window.fetch = async function(resource, options) {
	  const response = await originalFetch.apply(this, arguments); // Call the original fetch
  

	  if (typeof resource === "string" && (resource.includes('/cart/add.js') || resource.includes('/cart/change.js') || resource.includes('/cart/update.js'))) {
		document.dispatchEvent(event);
	  }

	  // Check if the request URL contains "/cart/update.js"
	  if (typeof resource === "string" && resource.includes("/cart/update.js")) {
		console.log("Detected fetch to /cart/update.js!");
  
		// Trigger refreshCart after detecting this request
		if (typeof window.refreshCart === "function") {
		  console.log("Refreshing cart...");
		  window.refreshCart(false, false);
		} else {
		  console.warn("window.refreshCart is not defined");
		}
	  }
  
	  return response; // Return the original response so nothing breaks
	};
  })();

(function() {
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('viewcart')) {
		if (window.refreshCart) window.refreshCart();
		const cartSidebar = document.querySelector('sidebar-drawer#site-cart-sidebar');
		if (cartSidebar) {
			cartSidebar.show();
		}
	}
})();